import React from 'react';
import { compose } from 'redux';
import { ShopItemType } from '../../../../../types/shop';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
}

const enhance = compose(withSectionFetchSpinner);
export class ShopDas extends React.Component<Props> {
  render() {
    const { className } = this.props;

    return (
      <div className={s['section-with-no-header']}>
        <ShopGrid className={className} itemType={ShopItemType.DAS} />
      </div>
    );
  }
}

export default enhance(ShopDas) as React.ComponentType<Props>;
